import {React, classNames, observer, StyledProps, withStyles} from '@api'
import { Typography, Tooltip} from '@material-ui/core'
import { ArrowBack, DeleteOutline, RemoveCircleOutline } from '@material-ui/icons'
import {useStores} from '@modules'
import {CentricTheme, PrimaryIconButton, DrawerTitleLocation, LibrarySidebarTabs} from 'centric-ui-components'
import * as css from './SideBarHeader.css'
import { DuplicateIcon } from '../icons';
import { Fragment } from 'react';
import {nav, site} from '@stores';
import { Tooltip2 } from '@api';

const styles = (theme: CentricTheme) => ({
  titleContainerOverlay: {
    padding: `0 ${theme.spacing() / 2}px 0 ${theme.spacing() * 2}px`,
  },

  icon: {
    height: 20,
    width: 20
  },
  tab: {
    minWidth: 60,
    minHeight: 64
  },
  lastIconMargin: {
    marginRight: 20
  },
  actionIcon: {
    color: `${theme.colors.white} !important`,
  },
  shrinkIcon: {
    width: 20,
    height: 20
  },
  lightIcon: {
    color: 'var(--icon-grey-2)'
  },
  popper: {
    zIndex: '1000000 !important'
  }
})

interface MyProps extends StyledProps {
  title?: string,
  isMore?: boolean
  isClose?: boolean
  onClickDrawerBack?: (e) => void
  onClickLibraryItemClose?: () => void
  alignEl?: any
  onClickMoreMenu?: (event, type, info) => void
  info?: any
  variant?: 'permanent' | 'persistent' | 'temporary'
  goBackText?: string
  open?: boolean,
  isFilters?: boolean,
  isTabs?: boolean
  onDeleteClick?: (e) => void
  onDuplicateClick?: (e) => void
  deleteTitle?: string
  location?: DrawerTitleLocation
  extra?: React.ReactNode
}

export const SideBarHeaderInternal = observer<MyProps>(function SideBarHeader(props) {
    const {strings} = useStores()
    const {
      className,
      title,
      isMore,
      classes,
      onClickDrawerBack,
      variant,
      goBackText,
      isTabs,
      onDuplicateClick,
      onDeleteClick,
      deleteTitle,
      location, extra
    } = props

    return (
      <div
        className={classNames(className, css.root, variant == 'temporary' && classes.titleContainerOverlay)}
        data-type='SideBarHeader'
        data-location={location}
        data-variant={variant}>
        {location == 'inline' && isTabs && <LibrarySidebarTabs />}
        {onClickDrawerBack &&
          <Tooltip2 content={goBackText || strings.goBack}>
            <PrimaryIconButton
              icon={<ArrowBack />}
              data-action='goBack'
              className={css.titleIcon }
              onClick={onClickDrawerBack}
            />
          </Tooltip2>
        }
        {title
          ? <Tooltip2 content={title ? title : ''}>
          <Typography variant={'body2'} className={classNames(css.title, isMore && css.long)} component='div'>
            {title}
          </Typography>
        </Tooltip2>
        : <Typography variant={'body2'} className={classNames(css.title, isMore && css.long)} component='div' />}
        {isMore && <Fragment>
          <Tooltip2 content={nav.isSeasonalLibraryView && nav.disableSpecActions ? strings.requiresCat2 : strings.duplicate} >
            <PrimaryIconButton
              icon={<DuplicateIcon />}
              onClick={onDuplicateClick}
              disabled={((nav.isSeasonalLibraryView && nav.disableSpecActions) || !title) ? true : false }
            />
          </Tooltip2>
          <Tooltip2 content={deleteTitle === 'Remove' && !nav.match.params.category2 ? strings.requiresCat2 : deleteTitle}>
            <PrimaryIconButton className={classNames(classes.lastIconMargin)}
              disabled={(deleteTitle === 'Remove' && !nav.match.params.category2) || !title}
              icon={'Remove' === deleteTitle ? <RemoveCircleOutline className={classNames(classes.actionIcon)}/> : <DeleteOutline className={classNames(classes.actionIcon)} />}
              onClick={onDeleteClick}
            />
          </Tooltip2>
        </Fragment>}
        {extra}
      </div>
    )
  })

SideBarHeaderInternal.defaultProps = {
  onClickMoreMenu: () => {
  },
  deleteTitle: 'Delete',
  location: 'inline'
}

export const SideBarHeader: any = withStyles(styles as any)(SideBarHeaderInternal)


// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/SideBarHeader.tsx